import { memo, useEffect } from 'react';
import { AgGridReact } from "ag-grid-react";

const AgGrid = memo(props => {
  // refresh header to toggle filters
  useEffect(() => {
    if (props.floatingFilter) {
      props.agGrid.refreshHeader();
    }
  });

  return <AgGridReact {...props} />;

}, (prevProps, nextProps) => {
  // re-render if one of these conditions:
  // - the rowModelType has been changed (quick edit toggles this and uses rowData, while normally infinite is used
  // - the columnDefs have been updated (columnsLastUpdate has been bumped)
  // - the filterModel has been changed (from Redux)
  let changed = prevProps.rowModelType !== nextProps.rowModelType ||
    prevProps.columnsLastUpdate !== nextProps.columnsLastUpdate;

  return !changed;
});

export default AgGrid;
